import { PropsWithChildren } from 'react';

const AnchorLink = ({
  anchor,
  highlightClass = 'highlighted',
  children,
  className,
}: PropsWithChildren<{
  anchor: string;
  highlightClass?: string;
  className?: string;
}>) => {
  const handleAnchorClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    const href = e.currentTarget.getAttribute('href');
    if (href) {
      const el = document.querySelector(href);
      if (el) {
        e.preventDefault();
        el.scrollIntoView({ behavior: 'smooth' });

        el.setAttribute('data-highlighted', 'true');
        el.classList.add(highlightClass);

        setTimeout(() => {
          el.removeAttribute('data-highlighted');
          el.classList.remove(highlightClass);
        }, 1000);
        return;
      }
    }
  };

  return (
    <a href={'#' + anchor} onClick={handleAnchorClick} className={className}>
      {children}
    </a>
  );
};

export default AnchorLink;
